import type { WishlistAccessSharingVisibilityOption } from '../../types/wishlist-access-sharing-visibility-option.interface';

export const WISHLIST_ACCESS_SHARING_EMAIL_PATTERN = new RegExp('^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$');

export const WISHLIST_ACCESS_SHARING_VISIBILITY_OPTIONS: readonly WishlistAccessSharingVisibilityOption[] = [
  {
    id: 'private',
    label: 'Tylko ja',
    description: 'Tylko Ty możesz ją otworzyć.',
    iconLabel: 'L',
  },
  {
    id: 'household',
    label: 'Domownicy',
    description: 'Dostęp dla osób z aktywnego domu.',
    iconLabel: 'H',
  },
  {
    id: 'invited_only',
    label: 'Zaproszone osoby',
    description: 'Dostęp tylko dla dodanych emaili.',
    iconLabel: '@',
  },
  {
    id: 'anyone_with_link',
    label: 'Każdy z linkiem',
    description: 'Każdy z aktywnym linkiem ją otworzy.',
    iconLabel: '#',
  },
];
